export default __webpack_public_path__ + "static/media/img-0429-hungary-full-face.7479f9de.png";